module.exports = require("core-js/modules/es.array.sort.js");